import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAtom } from 'jotai';
import { authUserAtom, authReadyAtom } from '@/stores/atoms/authAtoms';
import { initFirebase, onAuthStateChanged } from '@/utils/firebase';
import { getStoredAuthToken, getMyAccount } from '@/utils/userApi';
const AuthProvider = ({ children }) => {
    const [, setUser] = useAtom(authUserAtom);
    const [, setReady] = useAtom(authReadyAtom);
    React.useEffect(() => {
        let cleanup = null;
        (async () => {
            // 1) Prefer server JWT session if available
            try {
                const token = getStoredAuthToken();
                if (token) {
                    const me = await getMyAccount(token);
                    setUser({ uid: me.id, displayName: me.display_name, email: me.email, photoURL: me.avatar_url });
                    try {
                        localStorage.setItem('firebase_uid', me.id);
                    }
                    catch { }
                    setReady(true);
                    return; // Skip Firebase listener
                }
            }
            catch (e) {
                console.warn('AuthProvider: token restore failed:', e?.message || e);
            }
            // 2) Fallback to Firebase auth state
            try {
                initFirebase();
                const unsub = onAuthStateChanged((user) => {
                    // Ignore Firebase events if we already have a server token (e.g., after OAuth bridge)
                    const tk = getStoredAuthToken();
                    if (tk) {
                        setReady(true);
                        return;
                    }
                    if (user) {
                        setUser({ uid: user.uid, displayName: user.displayName, email: user.email, photoURL: user.photoURL });
                        try {
                            localStorage.setItem('firebase_uid', user.uid);
                        }
                        catch { }
                    }
                    else {
                        setUser(null);
                        try {
                            localStorage.removeItem('firebase_uid');
                        }
                        catch { }
                    }
                    setReady(true);
                });
                cleanup = () => { try {
                    unsub();
                }
                catch { } };
            }
            catch (e) {
                console.warn('Firebase disabled (init/auth error):', e?.message || e);
                setUser(null);
                setReady(true);
            }
        })();
        return () => { try {
            cleanup && cleanup();
        }
        catch { } };
    }, [setUser, setReady]);
    return _jsx(_Fragment, { children: children });
};
export default AuthProvider;
